import { Api } from "./Api";
import {
  msalInstance,
  backendRequestScope,
  silentRedirectUri
} from "../authconfig";
import { getRuntimeConfig } from "../runtimeConfig/runtime-config";

const getAuthenticatedApiClient = async () => {
  const account =
    msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

  if (!account) {
    throw new Error("No authenticated account found");
  }

  try {
    const tokenResponse = await msalInstance.acquireTokenSilent({
      ...backendRequestScope,
      account,
      redirectUri: silentRedirectUri
    });

    const apiClient = new Api({
      baseUrl: getRuntimeConfig().PUBLIC_API_URL,
      securityWorker: () => ({
        headers: {
          Authorization: `Bearer ${tokenResponse.accessToken}`
        }
      })
    });

    return apiClient;
  } catch (error) {
    console.error("Failed to acquire token for API client:", error);
    msalInstance.acquireTokenRedirect({
      ...backendRequestScope,
      account
    });
    throw error;
  }
};

export { getAuthenticatedApiClient };
